"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTL = void 0;
exports.TTL = {
    id: 'ttl',
    companyName: 'Total Transportation Ltd.',
    transportModes: ['sea'],
    freightGate: {
        isOnboarded: true,
        realm: 'ttl',
    },
    isInternal: false,
    isActive: false,
    countries: ['BD'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVFRMLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2FnZW50cy9kYXRhL1RUTC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLEdBQUcsR0FBVTtJQUN0QixFQUFFLEVBQUUsS0FBSztJQUNULFdBQVcsRUFBRSwyQkFBMkI7SUFDeEMsY0FBYyxFQUFFLENBQUMsS0FBSyxDQUFDO0lBQ3ZCLFdBQVcsRUFBRTtRQUNULFdBQVcsRUFBRSxJQUFJO1FBQ2pCLEtBQUssRUFBRSxLQUFLO0tBQ2Y7SUFDRCxVQUFVLEVBQUUsS0FBSztJQUNqQixRQUFRLEVBQUUsS0FBSztJQUNmLFNBQVMsRUFBRSxDQUFDLElBQUksQ0FBQztDQUNwQixDQUFBIn0=